<template lang='pug'>
  div
</template>

<script>
export default {
  name: 'FreqentlyAskedQuestions',
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>
